const NEW_UPI_PAYMENT_METHOD_PREFIX = "pm_nu";

export const NEW_UPI_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${NEW_UPI_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${NEW_UPI_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${NEW_UPI_PAYMENT_METHOD_PREFIX}_name`,
    DISABLE_MESSAGE: `${NEW_UPI_PAYMENT_METHOD_PREFIX}_disable_msg`,
    WE_ACCEPT_UPI_LIST: `${NEW_UPI_PAYMENT_METHOD_PREFIX}_waul`,
};
